import { HubFeature } from '@robovision/hub'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { queryClient } from '~services/query-client'
import {
  getEntitlementsQueryOptions,
  getFlagEntitlement,
  getLimitEntitlement,
} from '~utils/api/getEntitlements'


export function useEntitlementsQuery () {
  const { data } = useQuery(
    {
      ...getEntitlementsQueryOptions(),
      enabled: false,
    },
    queryClient,
  )

  return {
    entitlements: computed(() => data.value ?? []),
  }
}

export function useLimitEntitlement (feature: HubFeature) {
  const { entitlements } = useEntitlementsQuery()
  const entitlement = computed(() => getLimitEntitlement(entitlements.value, feature))

  return {
    entitlement,
    isGranted: computed(() => entitlement.value?.isGranted ?? false),
    isLapsed: computed(() => entitlement.value?.isLapsed ?? false),
    isLimitExceeded: computed(() => entitlement.value?.isLimitExceeded ?? false),
    isLimitReached: computed(() => entitlement.value?.isLimitReached ?? false),
    isOnLicense: computed(() => entitlement.value?.isOnLicense ?? false),
    usage: computed(() => entitlement.value?.usage),
  }
}

export function useFlagEntitlement (feature: HubFeature) {
  const {
    entitlements,
  } = useEntitlementsQuery()
  const entitlement = computed(() => getFlagEntitlement(entitlements.value, feature))

  return {
    entitlement,
    isGranted: computed(() => entitlement.value?.isGranted ?? false),
    isLapsed: computed(() => entitlement.value?.isLapsed ?? false),
    isOnLicense: computed(() => entitlement.value?.isOnLicense ?? false),
  }
}

export const useIndurionAgentEntitlement = () => useLimitEntitlement(HubFeature.IndurionAgent)

export const useDataDriftEntitlement = () => useFlagEntitlement(HubFeature.DataDrift)

export const useAreaMeasurementEntitlement = () => useFlagEntitlement(HubFeature.AreaMeasurement)
